import clsx from 'clsx';
import { Paragraph } from '@hungryroot/ui-kit';

import styles from './DetailedTermsAndConditions.module.css';

type DetailedTermsAndConditionsProps = {
  className?: string;
};

export function DetailedTermsAndConditions({
  className,
}: DetailedTermsAndConditionsProps) {
  return (
    <Paragraph className={clsx(className, styles.container)}>
      By creating an account, you agree to our{' '}
      <a className={styles.link} href="/terms/">
        Terms and Conditions
      </a>{' '}
      and{' '}
      <a className={styles.link} href="/privacy/">
        Privacy Policy
      </a>{' '}
      and to receive marketing emails. Unsubscribe at any time.
    </Paragraph>
  );
}
